/* tslint:disable */
/* eslint-disable */
/**
 * NinjaAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AZSchema
 */
export interface AZSchema {
    /**
     * 
     * @type {string}
     * @memberof AZSchema
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof AZSchema
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof AZSchema
     */
    type: string;
}

/**
 * Check if a given object implements the AZSchema interface.
 */
export function instanceOfAZSchema(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "type" in value;

    return isInstance;
}

export function AZSchemaFromJSON(json: any): AZSchema {
    return AZSchemaFromJSONTyped(json, false);
}

export function AZSchemaFromJSONTyped(json: any, ignoreDiscriminator: boolean): AZSchema {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'id': json['id'],
        'type': json['type'],
    };
}

export function AZSchemaToJSON(value?: AZSchema | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'id': value.id,
        'type': value.type,
    };
}

